<div class="bn-dialog">
  <div
    class="bn-dialog__close"
    (click)="onClose()">
    <fa-icon
      aria-label="Close"
      icon="xmark"
      size="lg" />
  </div>
  <div class="bn-dialog__cover">
    <img src="/assets/images/vrbunny.svg" />
  </div>
  <div class="bn-dialog__title">Sub-User Permissions Have Changed</div>
  <div class="bn-dialog__body">
    <p>To allow for continued development of new products and maintaining cross-product compatibility, we have changed the sub-user permission system.</p>
    <p>
      To continue using your account without issue, please make sure your account owner updates your account permissions. We apologise for any inconvenience
      this might cause.
    </p>
  </div>
  <div class="bn-dialog__actions row g-2">
    <div class="col mt-0">
      <button
        bn-web-ui-button
        itemStyle="primary"
        size="lg"
        [fullWidth]="true"
        (click)="onClose()">
        Continue
      </button>
    </div>
  </div>
</div>
